import CollectionsBrowser from './CollectionsBrowser';

export * from './CollectionsBrowser';
export default CollectionsBrowser;
